import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'app/auth/auth.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  public baseUrl: string;
  public newbaseUrl: string;
  selecteStateData: any = {};
  selecteCountryData: any = {};
  selecteIpdlocationdata:any = {};
  selecteCityData: any = {};
  httpClient: any;
  constructor(public http: HttpClient, public authservice: AuthService, public snackBar: MatSnackBar,) {
    this.baseUrl = this.authservice.baseUrl;
    this.newbaseUrl = this.authservice.newbaseUrl;
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    })
  }

  getState() {
    return this.http.get<any>(this.newbaseUrl + "LocationMaster/GetState/0")
  }
  getStatesByCountry(id){
    return this.http.get<any>(this.newbaseUrl + "StateMaster/" + id)
  }
  getDistrictsByState(id){
  return this.http.get<any>(this.newbaseUrl + "DistrictMaster/" + id)
  }

  getAreasByCity(id){
  return this.http.get<any>(this.newbaseUrl + "AreaMaster/" + id)
  }

  getCitiesByDistrict(id){
            return this.http.get<any>(this.newbaseUrl + "CityMaster/GetCityStateCountryByDistrictId/" + id)
  }
  addStateMaster(data: any) {
    return this.http.post<any>(this.newbaseUrl + "LocationMaster/InsertState", data)
  }

  getStateItem(id: any) {
    return this.http.get<any>(this.newbaseUrl + "LocationMaster/GetState/" + id)
  }

  getCity() {
    return this.http.get<any>(this.newbaseUrl + "LocationMaster/GetCity/0")
  }

  addCityMaster(data: any) {
    return this.http.post<any>(this.newbaseUrl + "LocationMaster/InsertCity", data)
  }
  addDistrictMaster(data: any) {
    return this.http.post<any>(this.newbaseUrl + "LocationMaster/InsertDistrict", data)
  }
  addareaMaster(data:any){
    return this.http.post<any>(this.newbaseUrl + "LocationMaster/InsertArea", data)
  }   
  getCityItem(id: any) {
    return this.http.get<any>(this.newbaseUrl + "LocationMaster/GetCity/" + id)
  }

  getAreaItem(id: any) {
    return this.http.get<any>(this.newbaseUrl + "LocationMaster/GetArea/" + id)

  }
  getCountry() {
    return this.http.get<any>(this.newbaseUrl + "CountryMaster/GetCountry/0")
  }

  addCountryMaster(data: any) {
    return this.http.post<any>(this.newbaseUrl + "CountryMaster/InsertCountry", data)
  }

  getCountryItem(id: any) {
    return this.http.get<any>(this.newbaseUrl + "CountryMaster/GetCountry/" + id)
  }

  getDistrict(id:any) {
    return this.http.get<any>(this.newbaseUrl + "LocationMaster/GetDistrict/" + id)
  }

  addRoom(data:any) {
    return this.http.post<any>(this.newbaseUrl + "Masters/InsertRoomMaster", data)
  }

  getRoom(id: any, id1: any) {
    return this.http.get<any>(`${this.newbaseUrl}Masters/GetRoomMasters/${id}/${id1}`);
  }

  getcompany(id: any) {
    return this.http.get<any>(this.newbaseUrl + "CompanyMaster/GetCompanyMasterByCompanyId/" + id)   
  }
  addCompany(data:any) {
    return this.http.post<any>(this.newbaseUrl + "CompanyMaster/InsertCompanyMaster", data)
  }

  getlanguage(id:any){
    return this.http.get<any>(this.newbaseUrl + "Common/GetLanguageMaster/" + id) 
  }
  addLanguage(data:any) {
    return this.http.post<any>(this.newbaseUrl + "Common/InsertLanguageMaster", data)
  }
  getbillingCompany(){
    return this.http.get<any>(this.newbaseUrl + "BillingCompany/GetBillingCompany") 
  }
  getPrefix(){
    return this.http.get<any>(this.newbaseUrl + "Masters/GetPrefixMaster") 
  }

  GetOPDManagerConfigWeb(){
    return this.http.get<any>(this.newbaseUrl + "Configuration/GetOPDManagerConfigWeb/"+this.authservice.Loggeduser.branchid+'/'+this.authservice.Loggeduser.specialityId) 
  }

  addopdmanagerConfigweb(data:any) {
    return this.http.post<any>(this.newbaseUrl + "Configuration/InsertOPDManagerConfigWeb", data)
  }

  getrateList(id: any, id1: any) {
    return this.http.get<any>(`${this.newbaseUrl}RateList/GetRateListMasterAllByBranchIdBySpecialityIdModule/${id}/${id1}`);
  }
  getallBranches(){
    return this.http.get<any>(this.newbaseUrl + "BranchMaster/GetBranchByUserId/" + 0)
  }
  GetIPDLocationMaster(transId){
    return this.http.get<any>(this.newbaseUrl + "LocationMaster/GetIPDLocationMaster/" + transId)
  }
  InsertIPDLocationMaster(payload:any){
    return this.http.post<any>(this.newbaseUrl + "LocationMaster/InsertIPDLocationMaster", payload)
  }
  InsertRateListMaster(payload:any){
    return this.http.post<any>(this.newbaseUrl + "RateList/InsertRateListMaster", payload)
  }
  getserviceByDepartmentId(DepId: any, CategoryId: any, RateListId: any, RateTypeId: any) {
    return this.http.get<any>(this.newbaseUrl + "RateList/GetRateListByDeptIdByCategoryIdRateListIdRateTypeId/" + DepId + "/" + CategoryId + "/" + RateListId + "/" + RateTypeId +'/'+this.authservice.Loggeduser.specialityId)
  }
  GetPayTypeMaster(id){
    return this.http.get<any>(this.newbaseUrl + "Masters/GetPayTypeMaster/" + id)
  }
  InsertPayTypeMaster(payload:any){
    return this.http.post<any>(this.newbaseUrl + "Masters/InsertPayTypeMaster", payload)
  }
  GetBillingTypeMaster(id){
    return this.http.get<any>(this.newbaseUrl + "Masters/GetBillingTypeMaster/" + id)
  }
  InsertBillingTypeMaster(payload:any){
    return this.http.post<any>(this.newbaseUrl + "Masters/InsertBillingTypeMaster", payload)
  }  
  getbillseriesMaster(id){
    return this.http.get<any>(this.newbaseUrl + "Masters/GetBillingSeriesMaster/" + id)
  }
  InsertbillseriesMaster(payload:any){
    return this.http.post<any>(this.newbaseUrl + "Masters/InsertBillingSeriesMaster", payload)
  } 
  GetBillSeriesRelationMasterByBranchIdByCompanyId(id: any, id1: any) {
    return this.http.get<any>(`${this.newbaseUrl}Masters/GetBillSeriesRelationMasterByBranchIdByCompanyId/${id}/${id1}`);
  }
  InsertBillingSeriesRelationMaster(payload:any){
    return this.http.post<any>(this.newbaseUrl + "Masters/InsertBillingSeriesRelationMaster", payload)
  }
  GetDoctorShareDetailByBranchIdByDoctorId(id: any, id1: any) {
    return this.http.get<any>(`${this.newbaseUrl}Masters/GetDoctorShareDetailByBranchIdByDoctorId/${id}/${id1}`);
  }
  InsertDoctorShareDetail(payload:any){
    return this.http.post<any>(this.newbaseUrl + "Masters/InsertDoctorShareDetail", payload)
  }
  InsertScheduleTypeMaster(payload:any){
    return this.http.post<any>(this.newbaseUrl + "Masters/InsertScheduleTypeMaster", payload)
  }
  GetScheduleTypeMaster(){
    return this.http.get<any>(this.newbaseUrl + "Masters/GetScheduleTypeMaster") 
  }
}

